{/* Base class, in particular for Privacy Policy and Terms and Conditions */}

export interface TableOfContentItemData {
    title: string;
    link?: string;
}

export const PageTitleSection = ({title, dateString}) => {
    return (
        <div className="border-b border-[#2A2F31]">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 text-center">
                <h1 className="text-4xl md:text-5xl font-extrabold tracking-tighter text-[#E3E6E8]">
                    {title}
                </h1>
                <p className="mt-4 text-lg text-[#9DA2A6]">
                    {dateString}
                </p>
            </div>
        </div>
    );
}


export const TableOfContents = ({tableItems}: { tableItems: TableOfContentItemData[] }) => {
    return (
        <aside className="hidden md:block w-64 flex-shrink-0">
            <div className="sticky top-24">
                <h3 className="text-sm font-bold text-[#E3E6E8] tracking-wider uppercase mb-4">
                    On this page
                </h3>

                <ul id="toc-nav" className="space-y-1">

                    {tableItems.map((item, index) => (
                        <TableOfContentsSection
                            key={item.title || index}
                            link={item.link || "#"}
                            title={item.title}
                        />
                    ))}

                </ul>
            </div>
        </aside>
    );
}

export const TableOfContentsSection = ({link, title}) => {
    return (
        <>
            <li>
                <a href={link}
                   className="toc-link block py-2 text-[#9DA2A6] font-medium transition-colors 
                   duration-200 hover:text-[#E3E6E8] pl-[18px] focus:outline-none focus-visible:text-[#E3E6E8]">
                    {title}
                </a>
            </li>
        </>
    );
}


export const IntroductionParagraph = ({description}) => {
    return (
        <>
            <p className="text-lg leading-relaxed text-[#E3E6E8] mb-8">
                {description}
            </p>
        </>
    );
}

export const SectionDescription = ({sectionId, subject, description}) => {
    return (
        <section id={sectionId} className="scroll-mt-24">
            <h2 className="text-2xl md:text-3xl font-bold text-[#E3E6E8] mt-12 first:mt-0 mb-6 border-b border-[#2A2F31] pb-4">
                {subject}
            </h2>
            <p className="text-base text-[#9DA2A6] leading-relaxed mb-4">
                {description}
            </p>
        </section>
    );
}






















